// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__zVvho","queue":"Monitor_queue__XqkHt"};